import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} DataField
 * @prop {string} data Data inside the data field
 * @prop {number} index Display index
 * @prop {string} type Type
 * @prop {string} viewMoniker Title of the data field
 */
export default PropTypes.shape({
  data: PropTypes.string,
  index: PropTypes.number,
  type: PropTypes.string,
  viewMoniker: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/dataFields.js